module.exports = __webpack_public_path__ + "static/media/montagem_ornamentos_en.7f8ccbed.png";